<template>
    <HeaderList :show-actions="!loading && !error && audiences.length > 0">
        <template #content>
            <h1 class="name">{{ $t('views.audiences.title') }}</h1>
            <p>{{ $t('views.audiences.description') }}</p>
        </template>
        <template #actions>
            <router-link class="btn-1 btn-s-icon" :to="{ name: 'companies' }">
                <div class="icon-plus-pos"></div>
            </router-link>
        </template>
    </HeaderList>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAudiencesStore } from '@/stores/audiences';
    import HeaderList from '@/components/sections/HeaderList';

    export default {
        name: "AudiencesHeader",
        components: {
            HeaderList
        },
        computed: {
            ...mapState(useAudiencesStore, ['audiences', 'loading', 'error']),
        },
    }
</script>
